import { formateDateInDateMonthYear } from 'wisestep-base';

export const tabNames = () => [
  {
    tabName: 'Overview',
  },
  {
    tabName: 'User Details',
  },
  {
    tabName: 'Settings',
  },
  {
    tabName: 'Activity',
  },
  {
    tabName: 'Communication',
  },
  {
    tabName: 'User Access',
  },
];

export const filteredTabNames = (isLink: boolean) => {
  return tabNames().filter((tab) => !isLink || tab.tabName !== 'Settings');
};

export const topSection = (email, phoneNumber, altEmail, location, smsNumber, jobBoardAccount) => {
  return [
    { label: 'Email', value: email },
    { label: 'Phone Number', value: phoneNumber },
    { label: 'Alternate Email', value: altEmail },
    { label: 'Location', value: location },
    { label: 'SMS Number Allocated', value: smsNumber },
    { label: 'Job Board Search Account', value: jobBoardAccount },
  ];
};

export const bottomSection = (
  address,
  about,
  emailsConfigured,
  jobPublishingAccounts,
  calendarAccounts,
  clientsAllocated
) => {
  return [
    { label: 'Address', value: address },
    { label: 'About', value: about },
    { label: 'Emails Configured', value: emailsConfigured },
    { label: 'Job Publishing Account', value: jobPublishingAccounts },
    { label: 'Calendar Account Configuration', value: calendarAccounts },
    { label: 'Clients Allocated', value: clientsAllocated },
  ];
};

export const userDetails = (user, address, about) => {
  return [
    { label: 'Email', value: user.email },
    { label: 'Phone Number', value: user.phoneNumber },
    { label: 'Alternate Email', value: user.alternateEmails },
    {
      label: 'Location',
      value: `${
        user?.location?.city || user?.location?.state || user?.location?.country
          ? [user?.location?.city, user?.location?.state, user?.location?.country]
              .filter(Boolean)
              .join(', ')
          : '-'
      }`,
    },
    { label: 'Employee Id', value: user.employeeId },
    { label: 'DOB', value: formateDateInDateMonthYear(user.dob) },
    { label: 'Joining date', value: formateDateInDateMonthYear(user.joiningDate) },
    { label: 'Designation', value: user.designation },
    { label: 'Address', value: address },
    { label: 'About', value: about },
  ];
};
